module.exports = __webpack_public_path__ + "img/2_Nucleic_Acids_Research_cover.3b0e44ee.jpg";